var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ct",staticClass:"vbox-container",class:_vm.params.className,style:({padding:_vm.params.padding})},[_c('div',{staticClass:"handler"}),_vm._v(" "),_c('div',{staticClass:"vbox-row-ct"},_vm._l((_vm.params.rows),function(row,index){return _c('div',{key:index,ref:"rows",refInFor:true,staticClass:"vbox-row dragula-container"})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5db27ac6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/extend/layout/designer/vbox-designer.vue
// module id = 788
// module chunks = 0 1